export const Z_INDEX_BASE = 0;
export const Z_INDEX_HEADER = 10;
export const Z_INDEX_HEADER_OVERLAP = 20;
export const Z_INDEX_DROPDOWN = 30;
export const Z_INDEX_MENU_OVERLAY = 40;
export const Z_INDEX_DIALOG = 50;
export const Z_INDEX_DIALOG_TOP_CHATBOT = 10001;
